"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icons = _interopRequireDefault(require("./icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Zicon = _ref => {
  let {
    icon,
    color,
    customClass,
    className
  } = _ref;
  const props = {
    className: "z-icon ".concat(className || "", " ").concat(customClass || ""),
    style: {
      color
    }
  };
  let Icon = _icons.default[icon];
  if (!Icon) {
    return null;
  }
  return _react.default.createElement(Icon, props);
};
Zicon.propTypes = {
  icon: _propTypes.default.string.isRequired,
  color: _propTypes.default.string,
  customClass: _propTypes.default.string,
  className: _propTypes.default.string
};
Zicon.defaultProps = {
  icon: "default"
};
var _default = exports.default = Zicon;